import { node } from 'prop-types';
import React, { useEffect, useState } from 'react';
import BrowserContext from '../../contexts/BrowserContext';

const BrowserProvider = ({ children }) => {
  const [isBrowser, setIsBrowser] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') setIsBrowser(true);
  }, []);

  return (
    <BrowserContext.Provider value={isBrowser}>
      {children}
    </BrowserContext.Provider>
  );
};

BrowserProvider.propTypes = {
  children: node.isRequired,
};

export default BrowserProvider;
